var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.837,
    height: 68.289,
    viewBox: "0 0 72.837 68.289",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M16.2,0H40V20H0Z",
    transform: "translate(32.837 28)",
    fill: "#2e71fc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_2",
    "data-name": "Exclusion 2",
    d: "M22.5,45A22.5,22.5,0,0,1,6.59,6.59,22.5,22.5,0,0,1,38.41,38.41,22.353,22.353,0,0,1,22.5,45ZM19,24a4,4,0,0,0,0,8H30a4,4,0,1,0,0-8Zm-5-9a4,4,0,1,0,0,8H25a4,4,0,0,0,0-8Z",
    transform: "translate(10.837)",
    fill: "#2e71fc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M5.48-.287,30.547,0V18.663H15.717l-22.776.357Z",
    transform: "matrix(0.839, -0.545, 0.545, 0.839, 6.076, 48.493)",
    fill: "#2e71fc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M-2.06,0h31.3V11.519H-18.895Z",
    transform: "translate(43.599 56.77)",
    fill: "#2e71fc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/new-logo.8097cea7ae441b68b55232e00da517e0.svg";
export { ForwardRef as ReactComponent };